import { Injectable } from '@angular/core';

import { ColumnHandlerService } from '../../record/services/column-handler.service';
import { ReportNaamCellComponent } from '../components/cells/report-naam-cell/report-naam-cell.component';
import { ReportRow } from '../entities/report-row.entity';

export enum ReportColumn {
    Naam = 'naam'
}

@Injectable()
export class ReportsColumnHandlerService extends ColumnHandlerService<ReportRow> {
    constructor() {
        super();

        this.components.set(ReportColumn.Naam, ReportNaamCellComponent);
    }
}
